var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.queryParams },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "诊所名称" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryParams.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "keyword", $$v)
                          },
                          expression: "queryParams.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属地区" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.regionOptions,
                          props: {
                            value: "key",
                            label: "value",
                            expandTrigger: "hover",
                          },
                          clearable: "",
                          placeholder: "选择地区",
                        },
                        on: { change: _vm.handleRegionChange },
                        model: {
                          value: _vm.queryParams.regionIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "regionIds", $$v)
                          },
                          expression: "queryParams.regionIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "选择状态" },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "-1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "启用", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "禁用", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleQuery },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.resetQuery } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:dental:clinic:save"],
                      expression: "['admin:dental:clinic:save']",
                    },
                  ],
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Logo", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.logo
                          ? _c(
                              "el-image",
                              {
                                staticStyle: {
                                  width: "50px",
                                  height: "50px",
                                  "border-radius": "4px",
                                },
                                attrs: {
                                  src: scope.row.logo,
                                  fit: "cover",
                                  "preview-src-list": [scope.row.logo],
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _c("div", { staticClass: "no-logo" }, [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "诊所名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactPerson", label: "联系人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactPhone", label: "联系人电话" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "regionName", label: "所属地区" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.regionName || scope.row.region || "暂无"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "地址" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status === 1 ? "success" : "info",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.status === 1 ? "上架" : "下架"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createdAt", label: "创建时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.createdAt || "无") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "查看", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-view",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetail(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "编辑", placement: "top" } },
                          [
                            _c("el-button", {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:dental:clinic:update"],
                                  expression: "['admin:dental:clinic:update']",
                                },
                              ],
                              attrs: {
                                type: "success",
                                icon: "el-icon-edit",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "绑定商品", placement: "top" } },
                          [
                            _c("el-button", {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:dental:clinic:bindProducts"],
                                  expression:
                                    "['admin:dental:clinic:bindProducts']",
                                },
                              ],
                              attrs: {
                                type: "warning",
                                icon: "el-icon-goods",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBindProducts(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "分销授权", placement: "top" } },
                          [
                            _c("el-button", {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:dental:clinic:distributor"],
                                  expression:
                                    "['admin:dental:clinic:distributor']",
                                },
                              ],
                              attrs: {
                                type: "warning",
                                icon: "el-icon-s-promotion",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDistribution(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "删除", placement: "top" } },
                          [
                            _c("el-button", {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:dental:clinic:delete"],
                                  expression: "['admin:dental:clinic:delete']",
                                },
                              ],
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini",
                                circle: "",
                                disabled: scope.row.status === 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              "current-page": _vm.queryParams.pageNum,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryParams.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "诊所名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入诊所名称" },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "副标题", prop: "subTitle" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入副标题" },
                            model: {
                              value: _vm.form.subTitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "subTitle", $$v)
                              },
                              expression: "form.subTitle",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人", prop: "contactPerson" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入联系人" },
                            model: {
                              value: _vm.form.contactPerson,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactPerson", $$v)
                              },
                              expression: "form.contactPerson",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "联系人电话", prop: "contactPhone" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "请输入联系人电话(手机或座机需要加区号)",
                            },
                            model: {
                              value: _vm.form.contactPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactPhone", $$v)
                              },
                              expression: "form.contactPhone",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "form-tip" }, [
                            _vm._v("座机格式：区号-电话号码，如：028-88889999"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属地区", prop: "regionIds" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.formRegionOptions,
                      props: {
                        value: "id",
                        label: "name",
                        children: "child",
                        expandTrigger: "hover",
                      },
                      placeholder: "请选择所属地区",
                    },
                    model: {
                      value: _vm.form.regionIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "regionIds", $$v)
                      },
                      expression: "form.regionIds",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入地址" },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "经度", prop: "longitude" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入经度" },
                            model: {
                              value: _vm.form.longitude,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "longitude", $$v)
                              },
                              expression: "form.longitude",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "纬度", prop: "latitude" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入纬度" },
                            model: {
                              value: _vm.form.latitude,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "latitude", $$v)
                              },
                              expression: "form.latitude",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "预约开始时间",
                            prop: "appointmentStartTime",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              placeholder: "选择时间",
                            },
                            model: {
                              value: _vm.form.appointmentStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appointmentStartTime", $$v)
                              },
                              expression: "form.appointmentStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "预约结束时间",
                            prop: "appointmentEndTime",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              placeholder: "选择时间",
                            },
                            model: {
                              value: _vm.form.appointmentEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appointmentEndTime", $$v)
                              },
                              expression: "form.appointmentEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "诊所状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("诊所图片"),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "Logo", prop: "logo" } }, [
                _c("div", { staticClass: "img-upload" }, [
                  _vm.logoImageUrl
                    ? _c(
                        "div",
                        { staticClass: "upload-pic" },
                        [
                          _c("el-image", {
                            staticClass: "image",
                            attrs: { src: _vm.logoImageUrl, fit: "cover" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btndel",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleRemoveLogo($event)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "preview-overlay",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewLogo($event)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-zoom-in" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.logoImageUrl
                    ? _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: { click: _vm.selectLocalLogo },
                        },
                        [
                          _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    ref: "logoImageInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.handleLogoSelected },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v("请上传诊所Logo，仅支持一张图片"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "主图" } }, [
                _c(
                  "div",
                  { staticClass: "img-upload" },
                  [
                    _vm._l(_vm.mainImageList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "upload-pic" },
                        [
                          _c("el-image", {
                            staticClass: "image",
                            attrs: { src: item.url, fit: "cover" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btndel",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleRemoveImage(index, "main")
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "preview-overlay",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewImage(index, "main")
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-zoom-in" })]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.selectLocalImages("main")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "upLoad" }, [
                          _c("i", {
                            staticClass: "el-icon-camera cameraIconfont",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "mainImageInput",
                      staticStyle: { display: "none" },
                      attrs: { type: "file", accept: "image/*", multiple: "" },
                      on: {
                        change: function ($event) {
                          return _vm.handleLocalImageSelected("main", $event)
                        },
                      },
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v("可上传多张主图，第一张将作为默认显示图，最多上传5张"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "详情图" } }, [
                _c(
                  "div",
                  { staticClass: "img-upload" },
                  [
                    _vm._l(_vm.detailImageList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "upload-pic" },
                        [
                          _c("el-image", {
                            staticClass: "image",
                            attrs: { src: item.url, fit: "cover" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btndel",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleRemoveImage(index, "detail")
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "preview-overlay",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewImage(index, "detail")
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-zoom-in" })]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.selectLocalImages("detail")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "upLoad" }, [
                          _c("i", {
                            staticClass: "el-icon-camera cameraIconfont",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "detailImageInput",
                      staticStyle: { display: "none" },
                      attrs: { type: "file", accept: "image/*", multiple: "" },
                      on: {
                        change: function ($event) {
                          return _vm.handleLocalImageSelected("detail", $event)
                        },
                      },
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v("可上传多张详情图，最多上传10张"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("其他信息"),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "标签" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                plain: "",
                                size: "mini",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showTagInput = true
                                },
                              },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _vm._l(_vm.tagsList, function (tag) {
                            return _c(
                              "el-tag",
                              {
                                key: tag,
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-bottom": "10px",
                                },
                                attrs: { closable: "" },
                                on: {
                                  close: function ($event) {
                                    return _vm.handleTagClose(tag)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(tag) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.showTagInput
                            ? _c("el-input", {
                                ref: "saveTagInput",
                                staticClass: "input-new-tag",
                                attrs: { size: "small" },
                                on: { blur: _vm.handleAddTag },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleAddTag($event)
                                  },
                                },
                                model: {
                                  value: _vm.newTag,
                                  callback: function ($$v) {
                                    _vm.newTag = $$v
                                  },
                                  expression: "newTag",
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "简介" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.form.introduction,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "introduction", $$v)
                      },
                      expression: "form.introduction",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "诊所详情",
            visible: _vm.detailDialogVisible,
            width: "85%",
            "custom-class": "clinic-detail-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "detail-container",
            },
            [
              _c("div", { staticClass: "detail-header" }, [
                _c("div", { staticClass: "header-left" }, [
                  _c("div", { staticClass: "clinic-name" }, [
                    _vm._v(_vm._s(_vm.detail.name || "暂无名称")),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clinic-subtitle" }, [
                    _vm._v(_vm._s(_vm.detail.subTitle || "")),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-right" },
                  [
                    _c(
                      "el-tag",
                      {
                        staticClass: "status-tag",
                        attrs: {
                          type: _vm.detail.status === 1 ? "success" : "danger",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.detail.status === 1 ? "营业中" : "已关闭"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-content-wrapper" }, [
                _c("div", { staticClass: "detail-left-column" }, [
                  _vm.detail.logo
                    ? _c("div", { staticClass: "logo-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("诊所Logo")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content logo-content" },
                          [
                            _c(
                              "el-image",
                              {
                                staticClass: "clinic-logo",
                                attrs: { src: _vm.detail.logo, fit: "cover" },
                                on: { click: _vm.previewDetailLogo },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c("div", { staticClass: "empty-logo" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("诊所Logo")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "section-content empty-image-content",
                          },
                          [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无Logo")]),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.mainImageArray && _vm.mainImageArray.length > 0
                    ? _c("div", { staticClass: "main-image-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("诊所主图")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content" },
                          [
                            _c(
                              "el-carousel",
                              {
                                attrs: {
                                  interval: 4000,
                                  type: "card",
                                  height: "220px",
                                  "indicator-position": "outside",
                                  arrow: "always",
                                },
                              },
                              _vm._l(
                                _vm.mainImageArray,
                                function (image, index) {
                                  return _c(
                                    "el-carousel-item",
                                    { key: index },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticClass: "carousel-image",
                                          attrs: { src: image, fit: "cover" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previewDetailImage(
                                                index,
                                                "main"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "image-slot",
                                              attrs: { slot: "error" },
                                              slot: "error",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c("div", { staticClass: "empty-main-image" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("诊所主图")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "section-content empty-image-content",
                          },
                          [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无主图")]),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.detailImageArray && _vm.detailImageArray.length > 0
                    ? _c("div", { staticClass: "detail-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("详情图片")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content" },
                          [
                            _c(
                              "el-carousel",
                              {
                                attrs: {
                                  interval: 4000,
                                  type: "card",
                                  height: "220px",
                                  "indicator-position": "outside",
                                  arrow: "always",
                                },
                              },
                              _vm._l(
                                _vm.detailImageArray,
                                function (image, index) {
                                  return _c(
                                    "el-carousel-item",
                                    { key: index },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticClass: "carousel-image",
                                          attrs: { src: image, fit: "cover" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previewDetailImage(
                                                index,
                                                "detail"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "image-slot",
                                              attrs: { slot: "error" },
                                              slot: "error",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c("div", { staticClass: "detail-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("详情图片")]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content" }, [
                          _c("div", { staticClass: "empty-detail-image" }, [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无详情图")]),
                          ]),
                        ]),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-right-column" }, [
                  _c("div", { staticClass: "detail-section" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c("i", { staticClass: "el-icon-office-building" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("基本信息")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section-content" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-user" }),
                                  _vm._v(" 联系人"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.detail.contactPerson || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-phone" }),
                                  _vm._v(" 联系电话"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.detail.contactPhone || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", {
                                    staticClass: "el-icon-location-information",
                                  }),
                                  _vm._v(" 所属地区"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.detail.regionName || _vm.detail.region
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-time" }),
                                  _vm._v(" 预约时间"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.detail.appointmentStartTime || "暂无"
                                    ) +
                                      " - " +
                                      _vm._s(
                                        _vm.detail.appointmentEndTime || "暂无"
                                      )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", {
                                    staticClass: "el-icon-map-location",
                                  }),
                                  _vm._v(" 详细地址"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "info-value address-value" },
                                  [_vm._v(_vm._s(_vm.detail.address || "暂无"))]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-position" }),
                                  _vm._v(" 经度"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.detail.longitude || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _c("i", { staticClass: "el-icon-position" }),
                                  _vm._v(" 纬度"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-value" }, [
                                  _vm._v(_vm._s(_vm.detail.latitude || "暂无")),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.detailTagsList && _vm.detailTagsList.length > 0
                    ? _c("div", { staticClass: "detail-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-collection-tag" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("标签")]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content" }, [
                          _c(
                            "div",
                            { staticClass: "tags-container" },
                            _vm._l(_vm.detailTagsList, function (tag) {
                              return _c(
                                "el-tag",
                                {
                                  key: tag,
                                  staticClass: "detail-tag",
                                  attrs: { effect: "plain" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(tag) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detail.introduction
                    ? _c("div", { staticClass: "detail-section" }, [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-document" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("诊所简介")]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content" }, [
                          _c("div", { staticClass: "intro-container" }, [
                            _c("div", { staticClass: "intro-text" }, [
                              _vm._v(_vm._s(_vm.detail.introduction)),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["dental:clinic:product:bind"],
                          expression: "['dental:clinic:product:bind']",
                        },
                      ],
                      staticClass: "detail-section",
                    },
                    [
                      _c("div", { staticClass: "section-header" }, [
                        _c("i", { staticClass: "el-icon-shopping-cart-full" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("绑定商品")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:dental:clinic:bindProducts"],
                                    expression:
                                      "['admin:dental:clinic:bindProducts']",
                                  },
                                ],
                                attrs: { type: "primary", size: "mini" },
                                on: { click: _vm.handleBindProductsFromDetail },
                              },
                              [_vm._v("添加商品")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.productsLoading,
                                expression: "productsLoading",
                              },
                            ],
                            staticClass: "products-container",
                          },
                          [
                            _vm.clinicProducts.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "products-list" },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: _vm.clinicProducts,
                                          border: "",
                                          stripe: "",
                                          "header-cell-style": {
                                            background: "#f8f8f9",
                                            color: "#606266",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "商品图片",
                                            width: "80",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    scope.row.imageList &&
                                                    scope.row.imageList.length >
                                                      0
                                                      ? _c(
                                                          "el-image",
                                                          {
                                                            staticStyle: {
                                                              width: "50px",
                                                              height: "50px",
                                                              "border-radius":
                                                                "4px",
                                                            },
                                                            attrs: {
                                                              src: scope.row
                                                                .imageList[0],
                                                              fit: "cover",
                                                              "preview-src-list":
                                                                scope.row
                                                                  .imageList,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image-slot",
                                                                attrs: {
                                                                  slot: "error",
                                                                },
                                                                slot: "error",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-picture-outline",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "no-image",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-picture-outline",
                                                            }),
                                                          ]
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2954138192
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "productName",
                                            label: "商品名称",
                                            "min-width": "150",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "price",
                                            label: "售价",
                                            width: "80",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      { staticClass: "price" },
                                                      [
                                                        _vm._v(
                                                          "￥" +
                                                            _vm._s(
                                                              scope.row.price ||
                                                                "0.00"
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1767950000
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "status",
                                            label: "状态",
                                            width: "80",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type:
                                                            scope.row.status ===
                                                            1
                                                              ? "success"
                                                              : "info",
                                                          size: "mini",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              scope.row
                                                                .status === 1
                                                                ? "上架"
                                                                : "下架"
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            203297620
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "操作",
                                            width: "120",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          content: "查看详情",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("el-button", {
                                                          directives: [
                                                            {
                                                              name: "hasPermi",
                                                              rawName:
                                                                "v-hasPermi",
                                                              value: [
                                                                "admin:dental:clinic:info",
                                                              ],
                                                              expression:
                                                                "['admin:dental:clinic:info']",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "primary",
                                                            icon: "el-icon-view",
                                                            size: "mini",
                                                            circle: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.handleViewProductDetail(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          content: "解除绑定",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("el-button", {
                                                          directives: [
                                                            {
                                                              name: "hasPermi",
                                                              rawName:
                                                                "v-hasPermi",
                                                              value: [
                                                                "admin:dental:clinic:bindProducts",
                                                              ],
                                                              expression:
                                                                "['admin:dental:clinic:bindProducts']",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "danger",
                                                            icon: "el-icon-delete",
                                                            size: "mini",
                                                            circle: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.handleUnbindProduct(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4189962068
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "pagination-container" },
                                      [
                                        _c("el-pagination", {
                                          attrs: {
                                            background: "",
                                            "current-page":
                                              _vm.productsQuery.page,
                                            "page-sizes": [5, 10, 20],
                                            "page-size":
                                              _vm.productsQuery.limit,
                                            layout:
                                              "total, sizes, prev, pager, next",
                                            total: _vm.productsTotal,
                                          },
                                          on: {
                                            "update:currentPage": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.productsQuery,
                                                "page",
                                                $event
                                              )
                                            },
                                            "update:current-page": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.productsQuery,
                                                "page",
                                                $event
                                              )
                                            },
                                            "size-change":
                                              _vm.handleProductsSizeChange,
                                            "current-change":
                                              _vm.handleProductsCurrentChange,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "empty-products" }, [
                                  _c("i", { staticClass: "el-icon-goods" }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("暂无绑定商品")]),
                                ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:dental:clinic:update"],
                      expression: "['admin:dental:clinic:update']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.handleEditFromDetail },
                },
                [_vm._v("编 辑")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "preview-dialog",
          attrs: {
            visible: _vm.previewVisible,
            "append-to-body": "",
            "show-close": true,
            modal: true,
            "close-on-click-modal": true,
            "close-on-press-escape": true,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "preview-image-container",
              on: { click: _vm.closePreview },
            },
            [
              _c("img", {
                staticStyle: { "max-width": "100%", "max-height": "80vh" },
                attrs: { src: _vm.previewImageUrl },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "preview-close-hint" }, [
                _vm._v("点击图片关闭"),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("product-binding", {
        attrs: {
          visible: _vm.bindingDialogVisible,
          "clinic-id": _vm.currentClinicId,
          "clinic-name": _vm.currentClinicName,
        },
        on: {
          "update:visible": function ($event) {
            _vm.bindingDialogVisible = $event
          },
          success: _vm.handleProductsSuccess,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.productDetailDialogVisible,
            title: "商品详情",
            width: "700px",
            "append-to-body": "",
            "custom-class": "product-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.productDetailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentProductDetail
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.detailLoading,
                      expression: "detailLoading",
                    },
                  ],
                  staticClass: "product-detail-container",
                },
                [
                  _c("div", { staticClass: "product-header" }, [
                    _c(
                      "div",
                      { staticClass: "product-image" },
                      [
                        _vm.currentProductDetail.imageList &&
                        _vm.currentProductDetail.imageList.length > 0
                          ? _c(
                              "el-image",
                              {
                                staticStyle: {
                                  width: "120px",
                                  height: "120px",
                                  "border-radius": "8px",
                                  "box-shadow": "0 2px 12px 0 rgba(0,0,0,0.1)",
                                },
                                attrs: {
                                  src: _vm.currentProductDetail.imageList[0],
                                  fit: "cover",
                                  "preview-src-list":
                                    _vm.currentProductDetail.imageList,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "no-image",
                                staticStyle: {
                                  width: "120px",
                                  height: "120px",
                                  "border-radius": "8px",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                }),
                              ]
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-info" }, [
                      _c("h2", { staticClass: "product-name" }, [
                        _vm._v(_vm._s(_vm.currentProductDetail.productName)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "product-status" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.currentProductDetail.status === 1
                                    ? "success"
                                    : "info",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.currentProductDetail.status === 1
                                      ? "上架"
                                      : "下架"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentProductDetail.syncStatus === 1
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { type: "primary", effect: "plain" },
                                },
                                [_vm._v("默认加到诊所")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "price-info" }, [
                        _c("div", { staticClass: "current-price" }, [
                          _vm._v(
                            "¥" +
                              _vm._s(_vm.currentProductDetail.price || "0.00")
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.currentProductDetail.originalPrice
                          ? _c("div", { staticClass: "original-price" }, [
                              _vm._v(
                                "原价: ¥" +
                                  _vm._s(_vm.currentProductDetail.originalPrice)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tags-container" },
                        _vm._l(
                          _vm.currentProductDetail.tagList,
                          function (tag) {
                            return _c(
                              "el-tag",
                              {
                                key: tag,
                                staticStyle: {
                                  "margin-right": "5px",
                                  "margin-bottom": "5px",
                                },
                                attrs: {
                                  size: "mini",
                                  effect: "plain",
                                  type: "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(tag) +
                                    "\n            "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("商品详情"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-details" },
                    [
                      _c(
                        "el-descriptions",
                        { attrs: { column: 2, border: "" } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "商品ID" } },
                            [_vm._v(_vm._s(_vm.currentProductDetail.id))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "供应商" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.currentProductDetail.supplierName || "-"
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "成本价" } },
                            [
                              _vm._v(
                                "¥" +
                                  _vm._s(
                                    _vm.currentProductDetail.costPrice || "-"
                                  )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "材料费" } },
                            [
                              _vm._v(
                                "¥" +
                                  _vm._s(
                                    _vm.currentProductDetail.materialPrice ||
                                      "-"
                                  )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "检查费" } },
                            [
                              _vm._v(
                                "¥" +
                                  _vm._s(
                                    _vm.currentProductDetail.examPrice || "-"
                                  )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.currentProductDetail.createTime || "-"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentProductDetail.introduction
                        ? _c("div", { staticClass: "product-intro" }, [
                            _c("div", { staticClass: "intro-title" }, [
                              _vm._v("商品简介:"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "intro-content" }, [
                              _vm._v(
                                _vm._s(_vm.currentProductDetail.introduction)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.productDetailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分销授权",
            visible: _vm.distributionDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.distributionDialogVisible = $event
            },
            close: _vm.closeDistributionDialog,
          },
        },
        [
          _c(
            "div",
            { staticClass: "distribution-container" },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.selectedDistributions,
                    callback: function ($$v) {
                      _vm.selectedDistributions = $$v
                    },
                    expression: "selectedDistributions",
                  },
                },
                _vm._l(_vm.distributionList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "distribution-item" },
                    [
                      _c("el-checkbox", { attrs: { label: item.id } }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.distributionDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.distributionSubmitting,
                  },
                  on: { click: _vm.submitDistribution },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }